/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // SNOOW - Replace Shopify blog authors
  function replaceSnoowAuthors() {
    var authorSelectors = [
      'span.strong',
      'span.hero__kicker__item'
    ];

    authorSelectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(el) {
        var author = el.textContent.trim();

        if (author === 'Pär Westerlind' || author === 'Maria Westerlind') {
          el.textContent = 'Team SNOOW';
        }
      });
    });
  }

  // Run immediately
  replaceSnoowAuthors();

  // Run after page load
  document.addEventListener('DOMContentLoaded', replaceSnoowAuthors);

  // Handle dynamically loaded Pipeline content
  var snoowAuthorObserver = new MutationObserver(function() {
    replaceSnoowAuthors();
  });

  snoowAuthorObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    
    if (variant) {
      console.log('Variant —————————— ↓');
      console.log(variant);
      
      // PW - Uppdatera textraden dynamiskt på skärmen direkt vid variantbyte
      if (typeof window.updateAlternativeStock === 'function') {
        window.updateAlternativeStock(variant.id);
      }
    }
  });



  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


})();
